import React from "react";
import { Link } from "react-router-dom";

const HiringRequestCards = ({
  filteredHiringRequests,
  demandPlans,
  hiringManagers,
  visibleCount,
  DemandPlanning,
  departments
}) => {
  const draftRequests = filteredHiringRequests.filter(req => req.status === "Draft");

  const renderCard = (req, index) => {
    const role =
      req.request_type === "Forecast"
        ? demandPlans.find(dp => Number(dp.demand_id) === Number(req.demand_id))?.role
        : req.role_text;

    const managerObj = hiringManagers.find(m => Number(m.user_id) === Number(req.hiring_manager));
    const manager = managerObj ? `${managerObj.first_name || ''} ${managerObj.last_name || ''}`.trim() : '';
    const statusColor = req.status === "Draft" ? "bg-yellow-500" : "bg-green-500";

    return (
      <Link
        key={req.request_id}
        to={`/request-details`}
        state={{
          request: req,
          demandPlans,
          DemandPlanning,
          departments,
          hiringManagers
        }}
        className="group block p-2 bg-white border border-primary-100/50 rounded-xl transition-all duration-300 hover:bg-primary-100/10 hover:shadow-md"
      >
        <div className="flex flex-col gap-4 p-4">
          <div className="flex justify-between items-center">
            <div className="flex flex-col">
              <label>Reference Number</label>
              <label className="font-bold text-primary-800">{req.referenceNumber}</label>
            </div>
            <div className="flex items-center gap-1.5 text-base">
             
     <div className="flex items-center gap-1.5 text-sm flex-wrap justify-end">
  <div className={`${statusColor} size-3 rounded-full flex-shrink-0`}></div>
  <span className="text-primary-600 whitespace-nowrap">
    {req.status}
  </span>
  {(req.request_type === "Exceptional" || req.request_type === "Outsourced") && req.isFinanceManagerApproveRequired === true && (req.status === "Submitted" || req.status === "Approved") && (
    <>
      <span className="text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap" style={{ backgroundColor: req.isFinanceManagerApproved ? 'rgba(16, 185, 129, 0.12)' : 'rgba(245, 158, 11, 0.12)', color: req.isFinanceManagerApproved ? '#059669' : '#d97706' }}>
        {req.isFinanceManagerApproved ? '✓ Finance' : '● Finance'}
      </span>
      <span className="text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap" style={{ backgroundColor: req.isHRDirectorApproved ? 'rgba(16, 185, 129, 0.12)' : 'rgba(245, 158, 11, 0.12)', color: req.isHRDirectorApproved ? '#059669' : '#d97706' }}>
        {req.isHRDirectorApproved ? '✓ HR Dir' : '● HR Dir'}
      </span>
      <span className="text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap" style={{ backgroundColor: req.isCEOApproved ? 'rgba(16, 185, 129, 0.12)' : 'rgba(245, 158, 11, 0.12)', color: req.isCEOApproved ? '#059669' : '#d97706' }}>
        {req.isCEOApproved ? '✓ CEO' : '● CEO'}
      </span>
    </>
  )}
</div>
            </div>
          </div>

          <div className="flex flex-col">
            <label>Role</label>
            <label className="font-bold">{role}</label>
          </div>

          <div className="flex flex-col">
            <label>Grade</label>
            <label className="font-bold text-[#6B6B6B]">{req.position}</label>
          </div>

          <div className="flex flex-col">
            <label>Hiring Manager</label>
            <label className="font-bold text-[#6B6B6B]">{manager}</label>
          </div>

          <div className="flex flex-col">
            <label>Type</label>
            <label className="font-bold text-[#6B6B6B]">{req.request_type}</label>
          </div>

          {(req.request_type === "Exceptional" || req.request_type === "Outsourced") && req.hiring_Type && (
          <div className="flex flex-col">
            <label>Hiring Type</label>
            <label className="font-bold text-[#6B6B6B]">{req.hiring_Type}</label>
          </div>
          )}

          <div className="flex flex-col">
            <label>Planned Start Date</label>
            <label className="font-bold text-[#6B6B6B]">{new Date(req.planned_start_date).toLocaleDateString()}</label>
          </div>
        </div>
      </Link>
    );
  };

  const draftCards = draftRequests.map((req, idx) => renderCard(req, idx));
  const remaining = visibleCount - draftCards.length;
  const nonDraft = filteredHiringRequests.filter(req => req.status !== "Draft").slice(0, remaining);
  const nonDraftCards = nonDraft.map((req, idx) => renderCard(req, idx));

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 4xl:grid-cols-4 gap-2 sm:gap-3 md:gap-4 px-2 sm:px-4 pb-2 sm:pb-4">
      {[...draftCards, ...nonDraftCards]}
    </div>
  );
};

export default HiringRequestCards;
